import "./ToptraderList_styles.scss";
//import Tag from "./Tag";
import { useState, useRef,useEffect } from "react";
import PortfolioListItem from "./PortfolioListItem";
import glovar from './glovar'
//import { useFetchTodoToptraders } from "../utils/useFetchTodoToptraders";
//import { useFetchTodoPortfolio } from "../utils/useFetchTodoPortfolio";

export default ({ toptrader, cotis, grayScale, hidetitbenef,screen_id,current_port }) => {
  
  //console.log("PortfolioTopTraderList (NO EFFECT) current_port:"+current_port)
  var FROM_SCREEN=screen_id;
  var GRAY_SCALE=false;
  if (grayScale) { GRAY_SCALE=true; }
  var HIDE_TITBENEF=false;
  if(hidetitbenef) {HIDE_TITBENEF=true; }

  var TOPTRADER=toptrader;

  let scrl = useRef(null);
  const [scrollX, setscrollX] = useState(0);
  const [scrolEnd, setscrolEnd] = useState(false);

  
  const Tag = ({ data }) => {
    return <li>{data}</li>;
  };

  
  //var todoPortfolio=TOPTRADER.cartera_text;

  //var todoPortfolio=TOPTRADER.cartera;
  var todoPortfolio;

  


  if(current_port==1) {
   //todoPortfolio=TOPTRADER;
   try { todoPortfolio=glovar.CURRENT_PORTFOLIO.slice(); } catch(Exxx) {}
  }
  else {
    todoPortfolio=TOPTRADER.cartera;
  }



  //console.log("todoPortfolio:"+todoPortfolio)
  //console.log("SHOW MY PROFILE:"+JSON.stringify(glovar.SHOW_MY_PROFILE.cartera[0]))
  
  //todoPortfolio=`[{"CarteraID":"0","opID":"100","stockID":"1000","stock":"Disney","Benf":"1344.70","rent":"20.88","ent":"91.99","fent":"14-07-22","temp":"1657792650","obj":"190","stop":"138","idPOS":"0","acciones":"100","status":"0","sal":"90","fsal":"23-4-2020","tempsal":"1596992669","coti":111.2,"sentido":"1","garantia":"1","multi":"1","currency":"USD","m":"$","symbol":"DIS"},{"CarteraID":"0","opID":"100","stockID":"1000","stock":"Ford Motor","Benf":"1011.00","rent":"28.58","ent":"11.79","fent":"28-06-22","temp":"1656410250","obj":"18.35","stop":"10","idPOS":"0","acciones":300,"status":"0","sal":"90","fsal":"23-4-2020","tempsal":"1596992669","coti":15.16,"sentido":"1","garantia":"1","multi":"1","currency":"USD","m":"$","symbol":"F"},{"CarteraID":"0","opID":"100","stockID":"1000","stock":"AMD","Benf":"584.00","rent":"7.85","ent":"74.40","fent":"05-07-22","temp":"1657015050","obj":"150","stop":"72","idPOS":"0","acciones":100,"status":"0","sal":"90","fsal":"23-4-2020","tempsal":"1596992669","coti":80.24,"sentido":"1","garantia":"1","multi":"1","currency":"USD","m":"$","symbol":"AMD"},{"CarteraID":"0","opID":"100","stockID":"1000","stock":"Meta Platforms","Benf":"145.50","rent":"3.12","ent":"155.47","fent":"22-06-22","temp":"1655891850","obj":"395","stop":"120","idPOS":"0","acciones":"30","status":"0","sal":"90","fsal":"23-4-2020","tempsal":"1596992669","coti":160.32,"sentido":"1","garantia":"1","multi":"1","currency":"USD","m":"$","symbol":"META"},{"CarteraID":"0","opID":"100","stockID":"1000","stock":"LVMH","Benf":"961.30","rent":"17.83","ent":"539.07","fent":"22-06-22","temp":"1655891850","obj":"695","stop":"520","idPOS":"0","acciones":10,"status":"0","sal":"90","fsal":"23-4-2020","tempsal":"1596992669","coti":635.2,"sentido":"1","garantia":"1","multi":"1","currency":"EUR","m":"€","symbol":"MC.PA"},{"CarteraID":0,"opID":100,"stockID":1000,"stock":"Tesla","Benf":"-5287.90","rent":"-66.18","ent":"799","fent":"11-03-22","temp":"1646992650","obj":"1280","stop":"450","idPOS":0,"acciones":"10","status":0,"sal":0,"fsal":"00-00-00","tempsal":"1000000000","coti":270.21,"sentido":"1","garantia":"1","multi":"1","currency":"USD","m":"$","symbol":"TSLA"}]`;

  //todoPortfolio=JSON.parse(todoPortfolio)
  //todoPortfolio=JSON.parse("["+TOPTRADER.cartera_text+"]")

  
  //todoPortfolio=JSON.parse("["+TOPTRADER.cartera+"]")
  if(current_port==1) {
      
      try { todoPortfolio=JSON.parse("["+glovar.SHOW_MY_PROFILE.cartera+"]")
      }
      catch(Ex) {
       //console.log("PETADA Ex:"+Ex);
       //console.log("glovar.SHOW_MY_PROFILE.cartera:")
       //console.log(JSON.stringify(glovar.SHOW_MY_PROFILE.cartera));
 
       // Supongamos que jsonString es la cadena que contiene tu JSON.
       //let jsonString = glovar.SHOW_MY_PROFILE.cartera;
       let jsonString = typeof glovar.SHOW_MY_PROFILE.cartera === 'string'
     ? glovar.SHOW_MY_PROFILE.cartera
     : JSON.stringify(glovar.SHOW_MY_PROFILE.cartera);
 
       // Reemplaza la coma extra que sigue a la apertura del arreglo de corporateActions
       jsonString = jsonString.replace(/("corporateActions":\s*)\[,/g, '$1[');
 
       try {
         todoPortfolio = JSON.parse("[" + jsonString + "]");
         //console.log("parseado OK")
         //console.log(parsedData);
       } catch (e) {
     //console.error("Error al parsear el JSON:", e);
       }
 
       //todoPortfolio=JSON.parse(glovar.SHOW_MY_PROFILE.cartera)
 
      }
 
     try { todoPortfolio=glovar.CURRENT_PORTFOLIO.slice(); } catch(Exxx) {}
    }
    else {
     todoPortfolio=JSON.parse("["+TOPTRADER.cartera+"]")
     //try { todoPortfolio=glovar.CURRENT_PORTFOLIO.slice(); } catch(Exxx) {}
    }
  
  let todoCotisPortfolio=cotis;
  
  
    
    //const { todoCotisPortfolio, isFetchingCotis } = useFetchTodoPortfolio(ARRAY_PORT_COTIS)//"IAG.MC,EURUSD=X")


    //if (!isFetchingCotis) 
    {

//console.log("isFetchingCotis11:"+JSON.stringify(todoCotisPortfolio))

 for(let i=0; i<todoCotisPortfolio.length; i++) 
 {
  for(let j=0; j<todoPortfolio.length; j++) 
  {
   if(todoCotisPortfolio[i].symbol==todoPortfolio[j].symbol) 
   {
    try { todoPortfolio[j].entrada=todoPortfolio[j].ent; } catch(Exxxx) {}

    todoPortfolio[j].json=todoCotisPortfolio[i];

    //ahora calculamos los datos.
     if(todoPortfolio[j].sentido==1)  { //alcista
     let benef=((todoCotisPortfolio[i].regularMarketPrice-todoPortfolio[j].ent)*todoPortfolio[j].acciones)*todoPortfolio[j].multi;
     if(benef) 
     { 
      todoPortfolio[j].benef=benef;
      let rent=benef/(todoPortfolio[j].ent*todoPortfolio[j].acciones*todoPortfolio[j].multi) 
      if(rent) {todoPortfolio[j].rent=rent*100;}
     }
    }
    else {
     let benef=((todoPortfolio[j].ent-todoCotisPortfolio[i].regularMarketPrice)*todoPortfolio[j].acciones)*todoPortfolio[j].multi;
     if(benef) 
     { 
      todoPortfolio[j].benef=benef;
      let rent=benef/(todoPortfolio[j].ent*todoPortfolio[j].acciones*todoPortfolio[j].multi) 
      if(rent) {todoPortfolio[j].rent=rent*100;} 
     }
    }
    //break;
   }
   //todoPortfolio[i].benef=69;
  //todoPortfolio[i].rent=68;
  }
  
 }
     

 if(!GRAY_SCALE) {
  //console.log("Vuelvo a mostrar los items:"+console.log(JSON.stringify(todoPortfolio)))
      return (
            todoPortfolio.map((d, i) => (
                <PortfolioListItem  key={d.id}Toptrader={d} index={i} grayScale={false} hidetit={HIDE_TITBENEF}
                screen_id={FROM_SCREEN}></PortfolioListItem>
            ))
      );
  }
  else {
   
    return (
      todoPortfolio.map((d, i) => (
          <PortfolioListItem key={d.id} Toptrader={d} index={i}  grayScale={true} hidetit={HIDE_TITBENEF} 
          screen_id={FROM_SCREEN}></PortfolioListItem>
      ))
);
  }
      }

    //const  todoTopTraders = useFetchTodoToptraders()

  
}
